import { render, staticRenderFns } from "./SubscriptionFee.vue?vue&type=template&id=84bccd6a&"
import script from "./SubscriptionFee.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports